module.exports = __webpack_public_path__ + "media/images/emoticons/bleah-6030980db1fc54cc9b9faef0969203d6.gif";